import api from "@/plugins/axios";
import router from "@/router/index";
import { useGlobalStore } from "@/stores";

const actions = () => ({
  async createLivelihood(payload) {
    await api.post("/api/livelihood/create", payload);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "Livelihood has been successfully created",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/livelihood/overview");
  },

  async editLivelihood(payload) {
    await api.post(`/api/livelihood/${payload.id}`, payload.data);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "All changes have been saved!",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    // router.push("/dashboard");
  },

  async getLivelhoodOverview(payload) {
    const res = await api.get("/api/livelihood/overview", {
      params: payload,
    });
    this.overview = res.data.content;
    this.pagination.totalItems = res.data.totalElements;
    this.pagination.cuurentPage = res.data.number + 1;
    this.pagination.pageCount = res.data.totalPages;
  },

  async deleteLivelihood(payload) {
    await api.post(`/api/livelihood/${payload.id}/delete`);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "Livelihood has been deleted",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/livelihood/overview");
  },

  async downloadExcel(payload) {
    try {
      const response = await api.get("/api/livelihood/overview/export", {
        params: payload,
        responseType: "blob",
      });

      return response;
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  },

  async getLivelihood(payload) {
    const res = await api.get(`/api/livelihood/${payload.id}`);
    return res.data;
  },

  resetAction() {
    this.filters.keyword = null;
    this.filters.advanced = {
      title: null,
      currentlyWorking: [],
      iscoCode: null,
      completedCourses: [],
      route: [],
      trainingType: [],
      odysseaSupport: null,
      suitableJobs: [],
      projects: [],
      employmentStatus: [],
      branch: null,
      responsible: [],
      workSatisfaction: null,
      date: [],
    };
  },
});

export default actions;
